import { get } from 'lodash';

import { CONSTANT_FILTERS } from '../constants';

export const getFiltersInitialCount = (
  filterName: string,
  initialFilterObject: Record<string, unknown>,
  key: string,
) => {
  const isOnOutboundReferralStatus = key === 'referralStatus' && filterName !== 'inbound';

  const isOnConstantFilter = !!get(CONSTANT_FILTERS, key, false);

  if (key === 'questionType') {
    return {
      ...initialFilterObject,
      [key]: 0,
    };
  }

  if (isOnConstantFilter || isOnOutboundReferralStatus) {
    return {
      ...initialFilterObject,
      [key]: isOnOutboundReferralStatus ? CONSTANT_FILTERS[`${key}Outbound`].length : CONSTANT_FILTERS[key].length,
    };
  }

  // initialize lists we dont know the length with 0
  return {
    ...initialFilterObject,
    [key]: 0,
  };
};
